export class UnprocessedResolutionsSummaryGetRequest {}

export class UnprocessedResolutionsSummaryGetResponse {
  resolutionIds!:string[]
}
